import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubble2"><Path d="M22.002 3V19H12.1946L6.25195 22.2685V19H2.00195V3H22.002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble2;
